import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ChangeRoleRequestData = {
  data: Array<{
    /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
    entity_ids: string[];
    entity_type: 'Community';
    roles: string[];
    user_id: string;
    /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
  }>;
};

export const changeRoleInCommunity = async (params: ChangeRoleRequestData) =>
  apiClient.patch<undefined, ApiClientResponse<undefined>>(routes.community.changeRole, params);
